import { Heap } from '@datacamp/exercise-tracking';
const heapEventNameFromProjectorAction = projectorAction => {
  switch (projectorAction) {
    case 'player_time_updated':
      return 'VideoExercise - Player Time Updated';
    case 'playback_ended':
      return 'VideoExercise - Playback Ended';
    case 'player_paused':
      return 'VideoExercise - Player Paused';
    case 'player_playing':
      return 'VideoExercise - Player Playing';
    case 'player_quality_changed':
      return 'VideoExercise - Player Quality Changed';
    case 'player_rate_changed':
      return 'VideoExercise - Player Playback Rate Changed';
    case 'changed':
      return 'VideoExercise - Subtitle Changed';
    case 'player_fullscreen':
      return 'VideoExercise - Player Fullscreen Changed';
    case 'player_video_downloaded':
      return 'VideoExercise - Player Video Downloaded';
    case 'player_volume_changed':
      return 'VideoExercise - Player Volume Changed';
    case 'player_subtitles_opened':
      return 'VideoExercise - Player Subtitles Opened';
    default:
      return null;
  }
};
export const trackPlayerEvent = _ref => {
  let {
    action,
    category,
    label,
    property,
    value
  } = _ref;
  const heapEventName = heapEventNameFromProjectorAction(action);
  if (!heapEventName) {
    return;
  }
  Heap.trackEvent({
    heapEventProperties: {
      // @ts-expect-error this is not a valid event_category but is still allowed by Heap https://datacamp.atlassian.net/wiki/spaces/PRODENG/pages/2173796462/Heap+Event+properties#Event-categories
      event_category: category !== null && category !== void 0 ? category : 'projector_event',
      label,
      property,
      value
    },
    name: heapEventName
  });
};